import { memo, useEffect } from 'react';

const CLAAS_OAUTH_RESPONSE = 'claas-oauth2-response';

const queryToObject = (query) => {
  const parameters = new URLSearchParams(query);
  return Object.fromEntries(parameters.entries());
};

const DataIntegrationSuccessContainer = () => {
  useEffect(() => {
    const payload = queryToObject(window.location.search.split('?')[1]);
    const error = payload && payload.error;

    const channel = new BroadcastChannel('claas-auth');

    if (error) {
      channel.postMessage({
        type: CLAAS_OAUTH_RESPONSE,
        error: decodeURI(error) || 'OAuth error: An error has occurred.',
      });
    } else {
      channel.postMessage({
        type: CLAAS_OAUTH_RESPONSE,
        payload,
      });
    }

    return () => {
      channel.close();
    };
  }, []);

  return null;
};

export default memo(DataIntegrationSuccessContainer);
